<template>
    <component :is="theme.components.BaseElementLayout"
               :el$="el$"
    >
        <template slot="field">
            <slot name="prefix"></slot>
            <div class="b-form-group">
                <label :for="name" class="b-form-group"
                >
                    <b-form-radio-group
                        v-model="model"
                        :name="name"
                        :id="id"
                        :disabled="disabled"
                        :value="value"
                        :options="options"
                        button-variant="outline-primary"
                        size="lg"
                        buttons
                        @change="handleChange"
                    />
                    <span v-html="text"></span>
                </label>
            </div>
            <slot name="suffix"></slot>
        </template>

        <slot slot="label" name="label" :el$="el$"></slot>
        <slot slot="info" name="info" :el$="el$"></slot>
        <slot slot="before" name="before" :el$="el$"></slot>
        <slot slot="between" name="between" :el$="el$"></slot>
        <slot slot="error" name="error" :el$="el$"></slot>
        <slot slot="after" name="after" :el$="el$"></slot>
    </component>
</template>
<script>
import BaseElement from '@laraform/laraform/src/mixins/BaseElement'
import BaseValidation from '@laraform/laraform/src/mixins/BaseValidation'
import CanBeDisabled from "@laraform/laraform/src/mixins/CanBeDisabled";

export default {
    name: 'ButtonblockElement',
    mixins: [BaseElement, BaseValidation, CanBeDisabled],
    props: {
        schema: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            /**
             * Text appears next to the radio.
             *
             * @type {string}
             * @default null
             */
            text: null,

            /**
             * Value of the radio button.
             *
             * @type {str|num|bool}
             * @default '1'
             */
            radioValue: '1',

            /**
             * Value of element when the form is initially loaded or reseted.
             *
             * @type {str|num|bool}
             * @default null
             */
            defaultValue: null,

            /**
             * Whether the field is *disabled*.
             *
             * @type {boolean}
             * @default false
             */
            disabled: false,

            /**
             * Name of the input field.
             *
             * @type {string}
             * @default null
             */
            fieldName: null,
        }
    },
    methods: {

        /**
         * Checks the radio.
         *
         * @public
         * @returns {void}
         */
        check() {
            this.update(this.radioValue)
        },

        /**
         * Unhecks the radio.
         *
         * @public
         * @returns {void}
         */
        uncheck() {
            this.update(this.null)
        },
        log(arg) {
            console.log(arg);
        }
    },
    created() {
        this.$_copy([
            {'value': 'radioValue'}, 'text', 'fieldName'
        ])

        if (this.fieldName === null) {
            this.fieldName = this.name
        }

        if (this.id === null) {
            this.id = this.fieldName
        }
    },
}
</script>
